module.exports = __webpack_public_path__ + "images/marketing/SalesSurvey2016.pdf";